import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './deal-product.reducer';

export const DealProductDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dealProductEntity = useAppSelector(state => state.dealProduct.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dealProductDetailsHeading">
          <Translate contentKey="tycheApp.dealProduct.detail.title">DealProduct</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tycheApp.dealProduct.id">Id</Translate>
            </span>
          </dt>
          <dd>{dealProductEntity.id}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tycheApp.dealProduct.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{dealProductEntity.quantity}</dd>
          <dt>
            <span id="keyword">
              <Translate contentKey="tycheApp.dealProduct.keyword">Keyword</Translate>
            </span>
          </dt>
          <dd>{dealProductEntity.keyword}</dd>
          <dt>
            <Translate contentKey="tycheApp.dealProduct.product">Product</Translate>
          </dt>
          <dd>{dealProductEntity.product ? dealProductEntity.product.id : ''}</dd>
          <dt>
            <Translate contentKey="tycheApp.dealProduct.deal">Deal</Translate>
          </dt>
          <dd>{dealProductEntity.deal ? dealProductEntity.deal.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/deal-product" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/deal-product/${dealProductEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DealProductDetail;
